;(function( window, document, bq ){ window.jQuery(function($) { 'use strict';

bq.recommendationsViewer = function(element, options) {
    this.$el      = $(element);
    this.options  = $.extend(true, {}, bq.recommendationsViewer.DEFAULTS, this.$el.data(), options);
    this._systemItems    = [];
    this._orgItems       = [];
    this._modelStartDate = '';
    this._modelEndDate   = '';
    this._submissionStartDate = '';
    this._submissionEndDate   = '';
    this._modelBuildStatus    = '';
    this._configurableQueue   = [];
    this._configurableData    = [];
    this._configurableSkipped = [];
    this._configurableIndex   = 0;
    this._orderErrors    = [];
    this._orderWarnings  = [];
    this._simpleItems    = [];
    this._filterState    = { high: true, medium: true, low: true, org: true };
    this._selectedGroup  = '';
    this._searchTerm     = '';
    this._searchMatchKeys = null;
    this._searchItems    = [];
    this._fuse           = null;
    this.init();
};

bq.recommendationsViewer.DEFAULTS = {
    combinedUrl:                  '',
    cartUrl:                      '',
    productViewUrl:               '',
    writeConfirmationReasonsUrl:  '',
    supplierImageBaseUrl:         '',
    disableViewCategorization:    0,
    labels: {
        loadFailed:               'Failed to load recommendations.',
        noRecommendationsFound:   'No recommendations found.',
        modelFailed:              'There were some difficulties in building the latest model and we are looking into it. Please check back later.',
        modelPending:             'Your recommendations are currently being prepared. Please check back shortly.',
        uncategorized:            'Uncategorized',
        recommendedByBoth:        'Recommended by System and Organization',
        recommendedBySystem:      'Recommended by System',
        recommendedByOrg:         'Recommended by Organization',
        highConfidence:           'HIGH CONFIDENCE',
        mediumConfidence:         'MEDIUM CONFIDENCE',
        lowConfidence:            'LOW CONFIDENCE',
        orgRecommendation:        'ORG RECOMMENDATION',
        sku:                      'SKU:',
        supplier:                 'Supplier:',
        lastOrdered:              'Last ordered',
        on:                       'on',
        noOrderHistory:           'No order history',
        configure:                'Configure',
        skip:                     'Skip',
        restore:                  'Restore',
        productNotFound:          'Product not found',
        pleaseProvideReason:      'Please provide a reason...',
        reasonForQtyChange:       'Reason for change of quantity',
        reasonForSkipping:        'Reason for skipping item',
        itemsCouldNotBeAdded:     'Some items could not be added to cart',
        followingNotAdded:        'The following items were NOT added:',
        itemsAddedWithWarnings:   'Some items were added with warnings',
        followingAddedWithIssues: 'The following items WERE added but have issues:',
        correctErrorsAndRetry:    'Please correct the errors and try again.',
        warningsInCart:           'Items with warnings are in your cart. Click below to proceed to checkout.',
        goToCart:                 'Go to Cart',
        processing:               'Processing...',
        pleaseWait:               'Please wait while we add items to your cart.',
        added:                    'Added',
        of:                       'of',
        items:                    'items...',
        failedToAddToCart:        'Failed to add to cart',
        requestTimeout:           'Request timeout',
        success:                  'Success!',
        redirectingToCart:        'Redirecting to cart...',
        processingOrder:          'Processing your order...',
        skipThisItem:             'Skip This Item',
        confirmSkip:              'Confirm Skip',
        loadingOptions:           'Loading options...',
        noConfigOptions:          'No configuration options found.',
        failedToLoadConfig:       'Failed to load configuration options.',
        pleaseSelectOptions:      'Please select all required options.',
        addingToCart:             'Adding items to cart...',
        confirmOrder:             'Confirm Order',
        allGroups:                'All Forecasted Items',
        defaultGroup:             'Default'
    }
};

bq.recommendationsViewer.DEFAULT_GROUP = '__default__';

bq.recommendationsViewer.prototype = {
    init: function() {
        this._bindEvents();
        this._loadRecommendations();
    },

    _id: function() { return this.$el.attr('id'); },

    _imageHtml: function(imageUrl, supplierId, size) {
        var defaultUrl = this.options.supplierImageBaseUrl + 'placeholder.jpg';
        return bq.recommendations.buildImageHtml(imageUrl, supplierId, this.options.supplierImageBaseUrl, defaultUrl, size);
    },

    _getContentGroupId: function() { return ''; },

    _splitBySource: function(forecasts) {
        var sys = [], org = [];
        $.each(forecasts || [], function(_, item) {
            if (item.system === true || item.system === 1 || item.system === 'true') { sys.push(item); }
            if (item.org    === true || item.org    === 1 || item.org    === 'true') { org.push(item); }
        });
        return { system: sys, org: org };
    },

    _getItemKey: function(item) {
        var pid = item.product_id || item.productId;
        if (pid) { return 'product:' + String(pid); }
        return 'supplier:' + String(item.supplier_id || '') + '|' + String(item.supplier_sku || item.sku || '');
    },

    _itemMatches: function(item, productId, supplierId, sku) {
        if (productId) { return String(item.product_id || item.productId || '') === String(productId); }
        return String(item.supplier_id || '') === String(supplierId) && String(item.supplier_sku || item.sku || '') === String(sku);
    },

    _normalizeConfidence: function(level) { return String(level || '').toUpperCase(); },

    _cardMatchesFilters: function($card) {
        var hasSystem = String($card.attr('data-has-system') || '') === '1';
        var hasOrg    = String($card.attr('data-has-org')    || '') === '1';
        var conf      = this._normalizeConfidence($card.attr('data-confidence-level'));
        var f         = this._filterState;
        var matchSys  = false, matchOrg = false;
        if (hasSystem) {
            matchSys = conf === 'HIGH' ? f.high : conf === 'MEDIUM' ? f.medium : conf === 'LOW' ? f.low : (f.high || f.medium || f.low);
        }
        if (hasOrg) { matchOrg = f.org; }

        if (!(matchSys || matchOrg)) { return false; }

        if (this._selectedGroup) {
            var rawGroups = $card.attr('data-catalog-groups') || '[]';
            var cardGroups;
            try { cardGroups = JSON.parse(rawGroups); } catch (e) { cardGroups = []; }

            if (this._selectedGroup === bq.recommendationsViewer.DEFAULT_GROUP) {
                if (cardGroups.length) { return false; }
            } else if ($.inArray(this._selectedGroup, cardGroups) === -1) {
                return false;
            }
        }

        return this._searchMatchesCard($card);
    },

    _cardKey: function($card) {
        var pid = $card.attr('data-product-id');
        if (pid) { return 'product:' + String(pid); }
        return 'supplier:' + String($card.attr('data-supplier') || '') + '|' + String($card.attr('data-sku') || '');
    },

    _searchMatchesCard: function($card) {
        if (!this._searchMatchKeys) { return true; }
        return this._searchMatchKeys.hasOwnProperty(this._cardKey($card));
    },

    _normalizeSearchText: function(value) {
        return String(value || '').replace(/["'\s-]/g, '');
    },

    _copyForSearchIndex: function(items) {
        var self = this;
        return $.map(items || [], function(item) {
            return $.extend({}, item, {
                name: self._normalizeSearchText(item.name),
                sku: self._normalizeSearchText(item.sku),
                supplier_sku: self._normalizeSearchText(item.supplier_sku)
            });
        });
    },

    _buildSearchIndex: function(items) {
        if (typeof Fuse === 'undefined') { this._fuse = null; return; }
        this._fuse = new Fuse(items || [], {
            keys: ['name', 'supplier_sku', 'sku'],
            threshold: 0.3,
            minMatchCharLength: 3,
            ignoreLocation: true
        });
    },

    _computeSearchMatches: function() {
        var self = this;
        var term = this._normalizeSearchText(this._searchTerm).toLowerCase();
        if (!term) { this._searchMatchKeys = null; return; }

        var exact = {};
        $.each(this._searchItems, function(_, item) {
            var sku = String(item.sku || '').toLowerCase();
            var supplierSku = String(item.supplier_sku || '').toLowerCase();
            if (sku === term || supplierSku === term) {
                exact[self._getItemKey(item)] = true;
            }
        });
        if (!$.isEmptyObject(exact)) {
            this._searchMatchKeys = exact;
            return;
        }

        if (!this._fuse) { this._searchMatchKeys = {}; return; }
        var keys = {};
        $.each(this._fuse.search(term), function(_, result) {
            keys[self._getItemKey(result.item)] = true;
        });
        this._searchMatchKeys = keys;
    },

    _updateVisibleSummaryCounts: function() {
        var id = this._id();
        var $visible = $('#' + id + '-grouped-items .recommendation-item-card:visible');
        var highConf = 0;
        $visible.each(function() {
            var $c = $(this);
            if (String($c.attr('data-has-system') || '') === '1' && String($c.attr('data-confidence-level') || '').toUpperCase() === 'HIGH') { highConf++; }
        });
        $('#' + id + '-summary-forecasted .summary-value').text($visible.length);
        $('#' + id + '-summary-confidence .summary-value').text(highConf);
    },

    _applyFilters: function() {
        var self = this;
        var id   = this._id();
        var isNewDesign = typeof bq.getIsThemeNew === 'function'
            ? bq.getIsThemeNew()
            : $('body').is('.theme-new, .light-theme, .dark-theme');
        var $container = $('#' + id + '-grouped-items');
        var $filterEmpty = $('#' + id + '-filter-empty');
        $('#' + id + '-grouped-items .recommendation-item-card').each(function() {
            var $card = $(this);
            var show  = self._cardMatchesFilters($card);
            $card.attr('data-filter-visible', show ? '1' : '0');
            if (show) { $card.show(); } else { $card.hide(); }
        });
        $('#' + id + '-grouped-items .category-section').each(function() {
            var $section = $(this);
            $section.toggle($section.find('.recommendation-item-card[data-filter-visible="1"]').length > 0);
        });
        if (isNewDesign && $filterEmpty.length) {
            var hasItems = $container.find('.recommendation-item-card').length > 0;
            var hasVisibleItems = $container.find('.recommendation-item-card[data-filter-visible="1"]').length > 0;
            $filterEmpty.toggle(hasItems && !hasVisibleItems);
        }
        this._updateVisibleSummaryCounts();
        this._updateOrderSummary();
    },

    _updateSummaryCards: function(items) {
        var id = this._id();
        if (this._submissionStartDate && this._submissionEndDate) {
            var s = new Date(this._submissionStartDate);
            var e = new Date(this._submissionEndDate);
            e.setUTCDate(e.getUTCDate() - 1);
            var mn = ['January','February','March','April','May','June','July','August','September','October','November','December'];
            $('#' + id + '-summary-delivery .summary-value').text(mn[s.getUTCMonth()] + ' ' + String(s.getUTCDate()).padStart(2,'0') + ' - ' + mn[e.getUTCMonth()] + ' ' + String(e.getUTCDate()).padStart(2,'0'));
        } else if (this._modelEndDate) {
            var d = new Date(this._modelEndDate);
            var mn2 = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
            $('#' + id + '-summary-delivery .summary-value').text(mn2[d.getMonth()] + ' ' + d.getDate());
        }
        this._updateVisibleSummaryCounts();
    },

    _updateOrderSummary: function() {
        var id         = this._id();
        var $allItems  = $('#' + id + '-grouped-items .recommendation-item-card');
        var $active    = $allItems.filter(':visible').not('.skipped-item');
        var totalValue = 0, totalItems = 0;
        $active.each(function() {
            var $c       = $(this);
            var priceText = $c.find('.item-price').text().trim();
            var qtyId    = $c.attr('data-qty-input-id');
            if (priceText && qtyId) {
                var qty      = parseInt($('#' + qtyId).val()) || 1;
                var priceVal = parseFloat(priceText.replace(/[^0-9.]/g, ''));
                if (!isNaN(priceVal) && !isNaN(qty)) { totalValue += priceVal * qty; totalItems++; }
            }
        });
        $('#' + id + '-total-value').text('$' + totalValue.toFixed(2));
        $('#' + id + '-total-items').text(totalItems);
        if ($allItems.filter(':visible').length > 0) {
            $('#' + id + '-order-summary').fadeIn(300);
        } else {
            $('#' + id + '-order-summary').fadeOut(300);
        }
    },

    _sortAndFilter: function() {
        var self = this;
        var map  = {};
        $.each(this._systemItems, function(_, item) {
            var key = self._getItemKey(item);
            if (!map[key]) { map[key] = $.extend({}, item); map[key].recommendation_source = 'SYS'; map[key].has_system = true; map[key].has_org = false; }
        });
        $.each(this._orgItems, function(_, item) {
            var key = self._getItemKey(item);
            if (!map[key]) { map[key] = $.extend({}, item); map[key].recommendation_source = 'ORG'; map[key].has_system = false; map[key].has_org = true; }
            else { map[key].has_org = true; map[key].recommendation_source = 'SYS'; }
        });
        var items = [];
        $.each(map, function(_, item) { items.push(item); });
        items.sort(function(a, b) {
            if (a.has_system && !b.has_system) return -1;
            if (!a.has_system && b.has_system) return 1;
            if (a.has_system && b.has_system) {
                return (a.recommendation_rank !== undefined ? a.recommendation_rank : 999999) -
                       (b.recommendation_rank !== undefined ? b.recommendation_rank : 999999);
            }
            return 0;
        });
        this._searchItems = this._copyForSearchIndex(items);
        this._buildSearchIndex(this._searchItems);
        this._computeSearchMatches();
        this._renderGroupedItems(items);
    },

    _removeItemFromMemory: function(productId, supplier, sku, source) {
        var self = this;
        if (source === 'SYS') {
            this._systemItems = $.grep(this._systemItems, function(item) { return !self._itemMatches(item, productId, supplier, sku); });
        } else if (source === 'ORG') {
            this._orgItems = $.grep(this._orgItems, function(item) { return !self._itemMatches(item, productId, supplier, sku); });
        }
    },

    _renderGroupedItems: function(items) {
        var self    = this;
        var id      = this._id();
        var labels  = bq.messages.recommendations;
        var isNewDesign = typeof bq.getIsThemeNew === 'function'
            ? bq.getIsThemeNew()
            : $('body').is('.theme-new, .light-theme, .dark-theme');
        var $container = $('#' + id + '-grouped-items');
        var $filterEmpty = $('#' + id + '-filter-empty');
        $container.empty();
        $filterEmpty.hide();

        if (!items || !items.length) {
            var emptyMsg = this._modelBuildStatus === 'FAILED'
                ? labels.modelFailed
                : (this._modelBuildStatus && this._modelBuildStatus !== 'COMPLETED' ? labels.modelPending : labels.noRecommendationsFound);
            $container.append('<div class="rec-empty-state">' + emptyMsg + '</div>').show();
            this._updateSummaryCards([]);
            return;
        }

        var grouped = {};
        if (this.options.disableViewCategorization) {
            grouped[''] = items;
        } else {
            $.each(items, function(_, item) {
                var cat = item.category_name || labels.uncategorized;
                if (!grouped[cat]) { grouped[cat] = []; }
                grouped[cat].push(item);
            });
        }

        $.each(grouped, function(categoryName, categoryItems) {
            var $section = $('<div class="category-section"></div>');
            if (categoryName) {
                var $header = $('<div class="' + (isNewDesign ? 'new-doc-header new-doc-heading' : 'category-header') + '"></div>');
                $header.append('<span class="category-icon">📦</span>');
                $header.append('<h3 class="' + (isNewDesign ? 'doc-heading-label' : 'category-name') + '">' + categoryName + '</h3>');
                $section.append($header);
            }
            var $itemsContainer = $('<div class="category-items"></div>');

            $.each(categoryItems, function(_, item) {
                var rowId       = 'rec-row-' + id + '-' + (item.index || item.pk || Math.random().toString(36).substr(2, 9));
                var qtyInputId  = 'qty-' + rowId;
                var maxSaleQty  = item.max_sale_qty && parseFloat(item.max_sale_qty) > 0 ? parseFloat(item.max_sale_qty) : 9999;
                var qtyInc      = item.qty_increments && parseFloat(item.qty_increments) > 0 ? parseFloat(item.qty_increments) : 1;
                var minSaleQty  = item.min_sale_qty && parseFloat(item.min_sale_qty) > 0 ? parseFloat(item.min_sale_qty) : 1;
                var initialQty  = Math.min(Math.max(item.quantity && item.quantity > 0 ? parseInt(item.quantity) : 1, minSaleQty), maxSaleQty);
                var externalIds = item.external_ids || [];
                var externalIdsJson = JSON.stringify(externalIds).replace(/"/g, '&quot;');
                var isConfigurable  = item.is_configurable || false;

                var recByText = '';
                if (item.has_system && item.has_org) { recByText = labels.recommendedByBoth; }
                else if (item.has_system) { recByText = labels.recommendedBySystem; }
                else if (item.has_org)   { recByText = labels.recommendedByOrg; }

                var confLevel = self._normalizeConfidence(item.confidence_level);
                var confPillHtml = '';
                if (item.has_system && confLevel) {
                    var confMod = confLevel === 'HIGH' ? 'high' : confLevel === 'MEDIUM' ? 'medium' : 'low';
                    var confText = confLevel === 'HIGH' ? labels.highConfidence : confLevel === 'MEDIUM' ? labels.mediumConfidence : labels.lowConfidence;
                    confPillHtml = '<span class="rec-item-confidence-pill rec-item-confidence-pill--' + confMod + '">' + confText + '</span>';
                } else if (item.has_org) {
                    confPillHtml = '<span class="rec-item-confidence-pill rec-item-confidence-pill--org">' + labels.orgRecommendation + '</span>';
                }

                var imgHtml = self._imageHtml(item.image, item.supplier_id, 80);
                var supplierSku = item.supplier_sku || item.sku || '';

                var nameHtml = '';
                if (item.name && item.url) {
                    nameHtml = '<a href="' + item.url + '">' + item.name + '</a>';
                } else if (item.name) {
                    nameHtml = item.name;
                }

                var priceHtml = item.price ? '<span class="item-price">' + item.price + '</span>' : '';

                var lastOrderText = '';
                if (item.last_order_quantity && item.last_order_date) {
                    var d = new Date(item.last_order_date);
                    var formattedDate = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'][d.getMonth()] + ' ' + d.getDate() + ', ' + d.getFullYear();
                    lastOrderText = '<span class="rec-item-last-order">' + labels.lastOrdered + ' ' + item.last_order_quantity + ' ' + labels.on + ' ' + formattedDate + '</span>';
                } else {
                    lastOrderText = '<span class="rec-item-no-order">' + labels.noOrderHistory + '</span>';
                }

                var cartParams = { id: item.product_id, qty: initialQty };
                var cartParamsJson = JSON.stringify(cartParams);

                var buttonsHtml = '';
                if (item.product_id && item.name) {
                    if (isConfigurable) {
                        buttonsHtml = '<a href="' + (item.url || '#') + '" class="btn btn-primary rec-btn--min-lg">' + labels.configure + '</a>';
                    } else {
                        buttonsHtml = '<button type="button" class="btn btn-default btn-skip-rec rec-btn--min-sm" data-row-id="' + rowId + '" data-skipped="false">' + labels.skip + '</button>';
                    }
                } else {
                    buttonsHtml = '<div class="rec-product-not-found">' + labels.productNotFound + '</div>';
                }

                var catalogGroupNames = (item.catalog_group_names && item.catalog_group_names.length)
                    ? item.catalog_group_names
                    : [];
                var catalogGroupsJson = JSON.stringify(catalogGroupNames);

                var $card = $('<div></div>').addClass('recommendation-item-card').attr({
                    id: rowId,
                    'data-product-id':          item.product_id || '',
                    'data-sku':                  supplierSku,
                    'data-supplier':             item.supplier_id || '',
                    'data-recommendation-source': item.recommendation_source || '',
                    'data-has-system':           item.has_system ? '1' : '0',
                    'data-has-org':              item.has_org    ? '1' : '0',
                    'data-confidence-level':     item.confidence_level || '',
                    'data-is-configurable':      isConfigurable ? '1' : '0',
                    'data-original-qty':         initialQty,
                    'data-qty-input-id':         qtyInputId,
                    'data-cart-params':          cartParamsJson,
                    'data-qty-increments':       qtyInc,
                    'data-min-sale-qty':         minSaleQty,
                    'data-max-sale-qty':         maxSaleQty,
                    'data-external-ids':         externalIdsJson,
                    'data-catalog-groups':       catalogGroupsJson
                });

                var qtyPillHtml = item.product_id
                    ? ('<div class="qty-pill qty-pill--rounded">' +
                       '<button type="button" class="qty-btn qty-decrement" data-qty-input="#' + qtyInputId + '">-</button>' +
                       '<input type="number" id="' + qtyInputId + '" class="product-qty" value="' + initialQty + '" min="' + minSaleQty + '" max="' + maxSaleQty + '" step="' + qtyInc + '" />' +
                       '<button type="button" class="qty-btn qty-increment" data-qty-input="#' + qtyInputId + '">+</button>' +
                       '</div>')
                    : '';

                var mainHtml =
                    '<div class="rec-card-row">' +
                    '<div class="item-image rec-card-image">' + imgHtml + '</div>' +
                    '<div class="rec-card-details">' +
                    '<div class="item-name rec-card-name">' + nameHtml + '</div>' +
                    '<div class="rec-card-meta"><strong>' + labels.skuLabel + '</strong> <span class="item-sku">' + supplierSku + '</span></div>' +
                    '<div class="rec-card-meta rec-card-meta--mb"><strong>' + labels.supplierLabel + '</strong> <span>' + (item.supplier_name || item.supplier_id || '') + '</span></div>' +
                    '<div class="rec-item-bottom-row">' + confPillHtml + lastOrderText + '</div>' +
                    '</div></div>' +
                    '<div class="rec-card-actions">' +
                    (priceHtml ? '<div>' + priceHtml + '</div>' : '') +
                    qtyPillHtml +
                    '<div>' + buttonsHtml + '</div>' +
                    '</div>';

                $card.html(mainHtml);

                var reasonBoxHtml =
                    '<div class="reason-box rec-reason-box" id="reason-box-' + rowId + '">' +
                    '<p class="rec-reason-box__label" id="reason-box-header-' + rowId + '">' + labels.reasonForQtyChange + '</p>' +
                    '<textarea id="reason-input-' + rowId + '" class="form-control rec-reason-box__textarea" rows="3" placeholder="' + labels.pleaseProvideReason + '"></textarea>' +
                    '</div>';
                $card.append(reasonBoxHtml);
                $itemsContainer.append($card);
            });

            $section.append($itemsContainer);
            $container.append($section);
        });

        $container.show();

        if (typeof bq !== 'undefined' && bq.global && typeof bq.global.registerAjaxActions === 'function') {
            bq.global.registerAjaxActions();
        }

        this._updateSummaryCards(items);
        this._setupQtyHandlers();
        this._setupSkipHandlers();
        this._populateCatalogGroupDropdown(items);

        var id = this._id();
        $('#' + id + '-grouped-items .product-qty').each(function() {
            var $input = $(this);
            var $card  = $input.closest('.recommendation-item-card');
            var qty    = parseInt($input.val()) || 1;
            var minQty = parseFloat($card.attr('data-min-sale-qty')) || 1;
            var maxQty = parseFloat($card.attr('data-max-sale-qty')) || 9999;
            var $pill  = $input.closest('.qty-pill');
            $pill.find('.qty-decrement').prop('disabled', qty <= minQty);
            $pill.find('.qty-increment').prop('disabled', qty >= maxQty);
        });

        this._applyFilters();
    },

    _setupQtyHandlers: function() {
        var self = this, id = this._id();
        $('#' + id + '-grouped-items')
            .off('click.qtyBtn').on('click.qtyBtn', '.qty-increment,.qty-decrement', function(e) {
                e.preventDefault();
                var $btn = $(this);
                var $input = $($btn.data('qty-input'));
                if (!$input.length) return;
                var $card    = $input.closest('.recommendation-item-card');
                var step     = parseFloat($card.attr('data-qty-increments')) || 1;
                var minQty   = parseFloat($card.attr('data-min-sale-qty'))   || 1;
                var maxQty   = parseFloat($card.attr('data-max-sale-qty'))   || 9999;
                var cur      = parseInt($input.val()) || minQty;
                var newQty   = $btn.hasClass('qty-increment') ? cur + step : cur - step;
                if (newQty < minQty) newQty = minQty;
                if (newQty > maxQty) newQty = maxQty;
                $input.val(newQty);
                var $pill = $input.closest('.qty-pill');
                $pill.find('.qty-decrement').prop('disabled', newQty <= minQty);
                $pill.find('.qty-increment').prop('disabled', newQty >= maxQty);
                self._onQtyChange($card, $input, newQty);
            })
            .off('change.qtyInput blur.qtyInput').on('change.qtyInput blur.qtyInput', '.product-qty', function() {
                var $input   = $(this);
                var $card    = $input.closest('.recommendation-item-card');
                var minQty   = parseFloat($card.attr('data-min-sale-qty')) || 1;
                var maxQty   = parseFloat($card.attr('data-max-sale-qty')) || 9999;
                var qty      = parseInt($input.val()) || minQty;
                if (qty < minQty) qty = minQty;
                if (qty > maxQty) qty = maxQty;
                $input.val(qty);
                var $pill = $input.closest('.qty-pill');
                $pill.find('.qty-decrement').prop('disabled', qty <= minQty);
                $pill.find('.qty-increment').prop('disabled', qty >= maxQty);
                self._onQtyChange($card, $input, qty);
            });
    },

    _onQtyChange: function($card, $input, newQty) {
        var labels    = bq.messages.recommendations;
        var rowId     = $card.attr('id');
        var cartParams = JSON.parse($card.attr('data-cart-params') || '{}');
        cartParams.qty = newQty;
        $card.attr('data-cart-params', JSON.stringify(cartParams));
        var originalQty = parseInt($card.attr('data-original-qty')) || 1;
        var $reasonBox  = $('#reason-box-' + rowId);
        var $reasonHeader = $('#reason-box-header-' + rowId);
        if (newQty !== originalQty) {
            $reasonHeader.text(labels.reasonForQtyChange);
            if (!$reasonBox.is(':visible')) { $reasonBox.slideDown(200); }
        } else {
            $reasonBox.slideUp(200);
        }
        this._updateOrderSummary();
    },

    _setupSkipHandlers: function() {
        var self   = this;
        var id     = this._id();
        var labels = bq.messages.recommendations;
        $('#' + id + '-grouped-items').off('click.skipRestore').on('click.skipRestore', '.btn-skip-rec', function() {
            var $button  = $(this);
            var rowId    = $button.data('row-id');
            var $card    = $('#' + rowId);
            var $reasonBox     = $('#reason-box-' + rowId);
            var $reasonHeader  = $('#reason-box-header-' + rowId);
            var $reasonTextarea = $('#reason-input-' + rowId);
            var isSkipped = $button.data('skipped') === true || $button.attr('data-skipped') === 'true';

            if (isSkipped) {
                var originalQty    = parseInt($card.attr('data-original-qty')) || 1;
                var qtyInputId     = $card.attr('data-qty-input-id');
                var $qtyInput      = $('#' + qtyInputId);
                var currentQty     = parseInt($qtyInput.val()) || originalQty;
                $card.removeClass('skipped-item');
                $card.find('.qty-btn, .product-qty').prop('disabled', false);
                $button.text(labels.skip).data('skipped', false).attr('data-skipped', 'false');
                if (currentQty !== originalQty) {
                    $reasonHeader.text(labels.reasonForQtyChange);
                    $reasonBox.slideDown(200);
                } else {
                    $reasonBox.slideUp(200);
                    $reasonTextarea.val('');
                }
                var cartParams = JSON.parse($card.attr('data-cart-params') || '{}');
                cartParams.qty = originalQty;
                $card.attr('data-cart-params', JSON.stringify(cartParams));
            } else {
                $card.addClass('skipped-item');
                $card.find('.qty-btn, .product-qty').prop('disabled', true);
                $button.text(labels.restore).data('skipped', true).attr('data-skipped', 'true');
                $reasonHeader.text(labels.reasonForSkipping);
                $reasonBox.slideDown(200);
            }
            self._updateOrderSummary();
        });
    },

    _loadRecommendations: function() {
        var self   = this;
        var id     = this._id();
        var labels = bq.messages.recommendations;

        $('#' + id + '-error').hide().text('');
        $('#' + id + '-grouped-items').hide();
        $('#' + id + '-loading').show();

        $.ajax({
            url: this.options.combinedUrl, type: 'POST', dataType: 'json', contentType: 'application/json',
            data: JSON.stringify({})
        }).done(function(resp) {
            $('#' + id + '-loading').hide();
            var hasData = resp && (resp.system_recommendations || resp.org_recommendations || resp.forecasts);
            var isOk    = resp && (resp.success === true || (resp.success === undefined && hasData));

            if (isOk || hasData) {
                if (resp.forecasts) {
                    var split = self._splitBySource(resp.forecasts);
                    self._systemItems = split.system;
                    self._orgItems    = split.org;
                } else {
                    self._systemItems = resp.system_recommendations || [];
                    self._orgItems    = resp.org_recommendations    || [];
                }
                self._modelStartDate      = resp.model_start_date      || '';
                self._modelEndDate        = resp.model_end_date        || '';
                self._submissionStartDate = resp.submission_start_date || '';
                self._submissionEndDate   = resp.submission_end_date   || '';
                self._modelBuildStatus    = resp.model_build_status    || '';
                self._sortAndFilter();
                $('#' + id + '-grouped-items').show();
            } else {
                var msg = resp && resp.message ? resp.message : labels.loadFailed;
                $('#' + id + '-error').text(msg).show();
            }
        }).fail(function(xhr) {
            $('#' + id + '-loading').hide();
            var msg = labels.loadFailed;
            if (xhr && xhr.responseJSON && xhr.responseJSON.message) { msg = xhr.responseJSON.message; }
            $('#' + id + '-error').text(msg).show();
        });
    },

    _reloadRecommendations: function(callback) {
        var self  = this;
        var id    = this._id();

        $('#' + id + '-loading').show();
        $('#' + id + '-grouped-items').hide();

        $.ajax({
            url: this.options.combinedUrl, type: 'POST', dataType: 'json', contentType: 'application/json',
            data: JSON.stringify({})
        }).always(function(resp) {
            $('#' + id + '-loading').hide();
            var hasData = resp && (resp.system_recommendations || resp.org_recommendations || resp.forecasts);
            var isOk    = resp && (resp.success === true || (resp.success === undefined && hasData));
            if (isOk || hasData) {
                if (resp.forecasts) {
                    var split = self._splitBySource(resp.forecasts);
                    self._systemItems = split.system; self._orgItems = split.org;
                } else {
                    self._systemItems = resp.system_recommendations || [];
                    self._orgItems    = resp.org_recommendations    || [];
                }
                self._sortAndFilter();
                $('#' + id + '-grouped-items').show();
            }
            if (typeof callback === 'function') { callback(); }
        });
    },

    _showErrorSummary: function(errors, warnings) {
        var self   = this;
        var id     = this._id();
        var labels = bq.messages.recommendations;

        var html = '<div class="alert alert-warning rec-error-summary">';
        if (errors.length > 0) {
            html += '<div class="rec-error-section"><h4 class="rec-error-title--errors"><span class="fa fa-exclamation-triangle"></span> ' + labels.itemsCouldNotBeAdded + '</h4>';
            html += '<p class="rec-error-desc--errors">' + labels.followingNotAdded + '</p><ul class="rec-error-list">';
            $.each(errors, function(_, e) {
                html += '<li class="rec-error-item--errors"><strong>' + e.productName + '</strong>';
                if (e.sku) { html += ' <span class="rec-error-sku">(SKU: ' + e.sku + ')</span>'; }
                html += '<br><span class="rec-error-detail">' + e.error + '</span></li>';
            });
            html += '</ul></div>';
        }
        if (warnings.length > 0) {
            html += '<div class="rec-error-section"><h4 class="rec-error-title--warnings"><span class="fa fa-info-circle"></span> ' + labels.itemsAddedWithWarnings + '</h4>';
            html += '<p class="rec-error-desc--warnings">' + labels.followingAddedWithIssues + '</p><ul class="rec-error-list">';
            $.each(warnings, function(_, w) {
                html += '<li class="rec-error-item--warnings"><strong>' + w.productName + '</strong>';
                if (w.sku) { html += ' <span class="rec-error-sku">(SKU: ' + w.sku + ')</span>'; }
                html += '<br><span class="rec-error-detail">' + w.warning + '</span></li>';
            });
            html += '</ul></div>';
        }
        if (errors.length > 0) {
            html += '<p class="rec-error-footer"><strong>' + labels.correctErrorsAndRetry + '</strong></p>';
        }
        if (warnings.length > 0 && errors.length === 0) {
            html += '<p class="rec-error-footer"><strong>' + labels.warningsInCart + '</strong></p>';
            html += '<br><button type="button" class="btn btn-primary" onclick="window.location.href=\'' + self.options.cartUrl + '\'"><span class="fa fa-shopping-cart"></span> ' + labels.goToCart + '</button>';
        }
        html += '</div>';
        $('#' + id + '-error').html(html).show();
    },

    _displayOrderErrors: function() {
        var self     = this;
        var id       = this._id();
        var errors   = this._orderErrors.slice();
        var warnings = this._orderWarnings.slice();

        $('#' + id + '-loading-overlay').hide();
        this._reloadRecommendations(function() {
            self._showErrorSummary(errors, warnings);
        });
    },

    _sendConfirmationReasons: function(reasons) {
        if (!reasons || !reasons.length) { return; }
        $.ajax({
            url: this.options.writeConfirmationReasonsUrl, type: 'POST', dataType: 'json', contentType: 'application/json',
            data: JSON.stringify({ product_reasons: reasons })
        });
    },

    _collectProductReasons: function() {
        var id      = this._id();
        var reasons = [];
        $('#' + id + '-grouped-items .recommendation-item-card').each(function() {
            var $card       = $(this);
            var rowId       = $card.attr('id');
            var reason      = $('#reason-input-' + rowId).val().trim();
            var isSkipped   = $card.hasClass('skipped-item');
            var origQty     = parseInt($card.attr('data-original-qty')) || 1;
            var qtyId       = $card.attr('data-qty-input-id');
            var curQty      = qtyId ? parseInt($('#' + qtyId).val()) || 1 : origQty;
            var qtyChanged  = curQty !== origQty;
            var isVisible   = $card.is(':visible');
            var externalIds = [];
            try { externalIds = JSON.parse(($card.attr('data-external-ids') || '[]').replace(/&quot;/g, '"')); } catch(e) {}
            if (!externalIds.length) { return; }
            if (!isSkipped && !qtyChanged && isVisible) { return; }
            if (!isVisible && !isSkipped) {
                reasons.push({ external_ids: externalIds, reason_type: 'SKIP', reason: '' });
            } else if (isSkipped) {
                reasons.push({ external_ids: externalIds, reason_type: 'SKIP', reason: reason });
            } else if (qtyChanged) {
                reasons.push({ external_ids: externalIds, reason_type: 'QTY_CHANGE', reason: reason, details: { original_qty: origQty, new_qty: curQty } });
            }
        });
        return reasons;
    },

    _addItemToCart: function(item, totalItems, completedItemsRef) {
        var self   = this;
        var id     = this._id();
        var labels = bq.messages.recommendations;

        return new Promise(function(resolve) {
            var completed = false, timeoutId;
            var $btn = $('<button type="button" data-bq="add-cart" style="display:none;"></button>');
            $btn.attr('data-params', JSON.stringify({ id: item.productId, qty: item.qty }));
            $btn.attr('data-product-id', item.productId);
            $btn.appendTo('body');

            if (typeof bq !== 'undefined' && bq.global && typeof bq.global.registerAjaxActions === 'function') {
                bq.global.registerAjaxActions();
            }

            var responseCaptured = false;
            var ajaxHandler = function(event, xhr, settings) {
                if (responseCaptured) return;
                if (settings && settings.url && settings.url.indexOf('ajax_actions/cart') !== -1) {
                    try { $btn.data('ajaxResponse', JSON.parse(xhr.responseText)); responseCaptured = true; } catch(e) {}
                }
            };
            $(document).on('ajaxComplete', ajaxHandler);

            var cleanup = function() {
                $(document).off('ajaxComplete', ajaxHandler);
                $btn.remove();
            };

            $btn.on('bq.ajaxAction.processDone', function(e, response) {
                if (completed) return;
                setTimeout(function() {
                    if (completed) return;
                    completed = true;
                    clearTimeout(timeoutId);
                    completedItemsRef.count++;
                    $('#' + id + '-loading-message').text(labels.added + ' ' + completedItemsRef.count + ' ' + labels.of + ' ' + totalItems + ' ' + labels.items);

                    var ajaxResp = $btn.data('ajaxResponse') || response;
                    if (!ajaxResp) {
                        self._removeItemFromMemory(item.productId, item.supplier, item.sku, item.recommendationSource);
                        cleanup(); resolve({ success: true, productName: item.productName }); return;
                    }

                    var errVal = String(ajaxResp.error || '').toLowerCase();
                    var hardError = errVal === 'true' || errVal === '1';
                    if (!hardError && ajaxResp.errors && typeof ajaxResp.errors === 'string' && !ajaxResp.warnings) { hardError = true; }
                    if (!hardError && (ajaxResp.success === false || ajaxResp.success === 'false')) { hardError = true; }
                    var errMsg  = ajaxResp.message || ajaxResp.errors || labels.failedToAddToCart;
                    var hasWarn = !!ajaxResp.warnings;
                    var warnMsg = hasWarn ? (Array.isArray(ajaxResp.warnings) ? ajaxResp.warnings.join('; ') : ajaxResp.warnings) : '';

                    if (hardError) {
                        self._orderErrors.push({ productId: item.productId, productName: item.productName, sku: item.sku, error: errMsg, type: 'simple' });
                        cleanup(); resolve({ success: false, error: errMsg, productName: item.productName }); return;
                    }
                    if (hasWarn) {
                        self._orderWarnings.push({ productId: item.productId, productName: item.productName, sku: item.sku, warning: warnMsg, type: 'simple' });
                    }
                    self._removeItemFromMemory(item.productId, item.supplier, item.sku, item.recommendationSource);
                    cleanup(); resolve({ success: true, hasWarnings: hasWarn, warning: warnMsg, productName: item.productName });
                }, 100);
            });

            $btn.on('bq.ajaxAction.error', function(e, errorData) {
                if (completed) return;
                completed = true; clearTimeout(timeoutId);
                completedItemsRef.count++;
                var errMsg = labels.failedToAddToCart;
                if (errorData) { errMsg = typeof errorData === 'string' ? errorData : (errorData.message || errorData.error || errMsg); }
                self._orderErrors.push({ productId: item.productId, productName: item.productName, sku: item.sku, error: errMsg, type: 'simple' });
                cleanup(); resolve({ success: false, error: errMsg, productName: item.productName });
            });

            timeoutId = setTimeout(function() {
                if (completed) return;
                completed = true; completedItemsRef.count++;
                self._orderErrors.push({ productId: item.productId, productName: item.productName, sku: item.sku, error: labels.requestTimeout, type: 'simple' });
                cleanup(); resolve({ success: false, error: 'timeout', productName: item.productName });
            }, 30000);

            $btn.trigger('click');
        });
    },

    _addConfigurableItemToCart: function(configData, totalItems, completedItemsRef) {
        var self   = this;
        var id     = this._id();
        var labels = bq.messages.recommendations;

        return new Promise(function(resolve) {
            var completed = false, timeoutId;
            var params = { id: configData.productId };
            $.each(configData.formData, function(_, field) {
                if (field.name === 'product') { return; }
                if (field.name.endsWith('[]')) {
                    var base = field.name.slice(0, -2);
                    if (!params[base]) { params[base] = []; }
                    params[base].push(field.value);
                } else {
                    params[field.name] = field.value;
                }
            });
            params.qty = configData.qty;

            var $btn = $('<button type="button" data-bq="add-cart" style="display:none;"></button>');
            $btn.attr('data-params', JSON.stringify(params));
            $btn.attr('data-product-id', configData.productId);
            $btn.appendTo('body');

            if (typeof bq !== 'undefined' && bq.global && typeof bq.global.registerAjaxActions === 'function') {
                bq.global.registerAjaxActions();
            }

            var responseCaptured = false;
            var ajaxHandler = function(event, xhr, settings) {
                if (responseCaptured) return;
                if (settings && settings.url && settings.url.indexOf('ajax_actions/cart') !== -1) {
                    try { $btn.data('ajaxResponse', JSON.parse(xhr.responseText)); responseCaptured = true; } catch(e) {}
                }
            };
            $(document).on('ajaxComplete', ajaxHandler);

            var cleanup = function() { $(document).off('ajaxComplete', ajaxHandler); $btn.remove(); };

            $btn.on('bq.ajaxAction.processDone', function(e, response) {
                if (completed) return;
                setTimeout(function() {
                    if (completed) return;
                    completed = true; clearTimeout(timeoutId);
                    completedItemsRef.count++;
                    $('#' + id + '-loading-message').text(labels.added + ' ' + completedItemsRef.count + ' ' + labels.of + ' ' + totalItems + ' ' + labels.items);

                    var ajaxResp = $btn.data('ajaxResponse') || response;
                    if (!ajaxResp) {
                        self._removeItemFromMemory(configData.productId, configData.supplier, configData.sku, configData.recommendationSource);
                        cleanup(); resolve({ success: true, productName: configData.productName }); return;
                    }
                    var errVal    = String(ajaxResp.error || '').toLowerCase();
                    var hardError = errVal === 'true' || errVal === '1';
                    if (!hardError && ajaxResp.errors && typeof ajaxResp.errors === 'string' && !ajaxResp.warnings) { hardError = true; }
                    if (!hardError && (ajaxResp.success === false || ajaxResp.success === 'false')) { hardError = true; }
                    var errMsg  = ajaxResp.message || ajaxResp.errors || labels.failedToAddToCart;
                    var hasWarn = !!ajaxResp.warnings;
                    var warnMsg = hasWarn ? (Array.isArray(ajaxResp.warnings) ? ajaxResp.warnings.join('; ') : ajaxResp.warnings) : '';

                    if (hardError) {
                        self._orderErrors.push({ productId: configData.productId, productName: configData.productName, sku: configData.sku, error: errMsg, type: 'configurable' });
                        cleanup(); resolve({ success: false, error: errMsg, productName: configData.productName }); return;
                    }
                    if (hasWarn) {
                        self._orderWarnings.push({ productId: configData.productId, productName: configData.productName, sku: configData.sku, warning: warnMsg, type: 'configurable' });
                    }
                    self._removeItemFromMemory(configData.productId, configData.supplier, configData.sku, configData.recommendationSource);
                    cleanup(); resolve({ success: true, hasWarnings: hasWarn, productName: configData.productName });
                }, 100);
            });

            $btn.on('bq.ajaxAction.error', function(e, errorData) {
                if (completed) return;
                completed = true; clearTimeout(timeoutId);
                completedItemsRef.count++;
                var errMsg = labels.failedToAddToCart;
                if (errorData) { errMsg = typeof errorData === 'string' ? errorData : (errorData.message || errorData.error || errMsg); }
                self._orderErrors.push({ productId: configData.productId, productName: configData.productName, sku: configData.sku, error: errMsg, type: 'configurable' });
                cleanup(); resolve({ success: false, error: errMsg, productName: configData.productName });
            });

            timeoutId = setTimeout(function() {
                if (completed) return;
                completed = true; completedItemsRef.count++;
                self._orderErrors.push({ productId: configData.productId, productName: configData.productName, sku: configData.sku, error: labels.requestTimeout, type: 'configurable' });
                cleanup(); resolve({ success: false, error: 'timeout', productName: configData.productName });
            }, 30000);

            $btn.trigger('click');
        });
    },

    _processAllConfiguredItems: function() {
        var self      = this;
        var id        = this._id();
        var labels    = bq.messages.recommendations;
        var totalItems = this._simpleItems.length + this._configurableData.length;

        $('#' + id + '-loading-overlay').css('display', 'flex');
        $('#' + id + '-loading-title').text(labels.processingOrder);
        $('#' + id + '-loading-message').text(labels.pleaseWait);

        if (this._configurableSkipped.length > 0) {
            this._sendConfirmationReasons(this._configurableSkipped);
        }

        if (totalItems === 0) { $('#' + id + '-loading-overlay').hide(); return; }

        var completedRef = { count: 0 };
        var simplePromises = [];
        var self = this;

        $.each(this._simpleItems, function(_, item) {
            simplePromises.push(self._addItemToCart(item, totalItems, completedRef));
        });

        Promise.allSettled(simplePromises).then(function() {
            var configResults = [];
            var addNext = function(index) {
                if (index >= self._configurableData.length) {
                    self._finalizeOrder();
                    return Promise.resolve();
                }
                return self._addConfigurableItemToCart(self._configurableData[index], totalItems, completedRef).then(function(result) {
                    configResults.push(result);
                    return addNext(index + 1);
                });
            };
            return addNext(0);
        });
    },

    _finalizeOrder: function() {
        var id     = this._id();
        var labels = bq.messages.recommendations;
        if (this._orderErrors.length > 0) {
            this._displayOrderErrors();
            return;
        }
        $('#' + id + '-loading-overlay').css('display', 'flex');
        $('#' + id + '-loading-title').text(labels.success);
        $('#' + id + '-loading-message').text(labels.redirectingToCart);
        var cartUrl = this.options.cartUrl;
        setTimeout(function() { window.location.href = cartUrl; }, 1000);
    },

    _processConfigurableItems: function() {
        var self   = this;
        var id     = this._id();
        var labels = bq.messages.recommendations;
        var $configurableCards = $('#' + id + '-grouped-items .recommendation-item-card[data-is-configurable="1"]:visible').not('.skipped-item');

        if (!$configurableCards.length) { return false; }

        this._configurableQueue   = [];
        this._configurableData    = [];
        this._configurableSkipped = [];
        this._configurableIndex   = 0;

        $configurableCards.each(function() {
            var $c = $(this);
            self._configurableQueue.push({
                productId:             $c.data('product-id'),
                productUrl:            $c.find('.item-name a').attr('href'),
                productName:           $c.find('.item-name').text().trim(),
                productImage:          $c.find('.item-image img').attr('src') || '',
                sku:                   $c.data('sku'),
                supplier:              $c.data('supplier'),
                recommendationSource:  $c.data('recommendation-source'),
                $card:                 $c,
                qtyInputId:            $c.attr('data-qty-input-id'),
                externalIds:           $c.attr('data-external-ids')
            });
        });

        $('#' + id + '-configurable-modal').modal({ backdrop: 'static', keyboard: false });
        this._showConfigurableItem(0);
        return true;
    },

    _showConfigurableItem: function(index) {
        var self   = this;
        var id     = this._id();
        var labels = bq.messages.recommendations;

        if (index >= this._configurableQueue.length) {
            $('#' + id + '-configurable-modal').modal('hide');
            this._processAllConfiguredItems();
            return;
        }

        this._configurableIndex = index;
        var item = this._configurableQueue[index];

        $('#' + id + '-config-progress').text('(' + (index + 1) + ' of ' + this._configurableQueue.length + ')');
        var imgHtml = this._imageHtml(item.productImage, item.supplier, 80);
        $('#' + id + '-config-item-info').html(
            '<div class="rec-config-item-info">' + imgHtml +
            '<div><h4 class="rec-config-item-title">' + item.productName + '</h4>' +
            '<div class="rec-config-item-sku">SKU: ' + item.sku + '</div></div></div>'
        );
        $('#' + id + '-config-skip-section').hide();
        $('#' + id + '-config-skip-reason').val('');
        $('#' + id + '-config-skip-btn').text(labels.skipThisItem);
        $('#' + id + '-config-options-container').html('<div class="rec-config-loading"><span class="fa fa-spinner fa-spin"></span> ' + labels.loadingOptions + '</div>');

        $.ajax({ url: this.options.productViewUrl, type: 'GET', data: { id: item.productId }, dataType: 'html' })
            .done(function(html) {
                var $html = $('<div>').html(html);
                var $opts = $html.find('#product-options-wrapper');
                if ($opts.length) {
                    var formHtml = '<form id="temp-config-form-' + item.productId + '" data-bq="validate-form">' +
                        '<input type="hidden" name="product" value="' + item.productId + '" />' +
                        $opts.html() + '</form>';
                    $('#' + id + '-config-options-container').html(formHtml);
                    if (typeof bq !== 'undefined' && bq.global && typeof bq.global.registerAjaxActions === 'function') { bq.global.registerAjaxActions(); }
                } else {
                    $('#' + id + '-config-options-container').html('<div class="alert alert-warning">' + labels.noConfigOptions + '</div>');
                }
            })
            .fail(function() {
                $('#' + id + '-config-options-container').html('<div class="alert alert-danger">' + labels.failedToLoadConfig + '</div>');
            });
    },

    _validateCurrentConfigForm: function() {
        var item    = this._configurableQueue[this._configurableIndex];
        var $form   = $('#temp-config-form-' + item.productId);
        var isValid = true;
        $form.find('[required]').each(function() {
            var v = $(this).val();
            if (!v || v === '' || v === '--Select--') { isValid = false; $(this).addClass('error'); }
            else { $(this).removeClass('error'); }
        });
        return isValid;
    },

    _captureCurrentConfigData: function() {
        var item = this._configurableQueue[this._configurableIndex];
        var $form = $('#temp-config-form-' + item.productId);
        if (!$form.length) { return; }
        var $card   = item.$card;
        var maxQty  = parseFloat($card.attr('data-max-sale-qty')) || 9999;
        var minQty  = parseFloat($card.attr('data-min-sale-qty')) || 1;
        var rawQty  = parseInt($('#' + item.qtyInputId).val()) || minQty;
        this._configurableData.push({
            productId:             item.productId,
            productName:           item.productName,
            formData:              $form.serializeArray(),
            qty:                   Math.min(Math.max(rawQty, minQty), maxQty),
            sku:                   item.sku,
            supplier:              item.supplier,
            recommendationSource:  item.recommendationSource,
            $card:                 item.$card,
            externalIds:           item.externalIds
        });
    },

    _allGroupsLabel: function() {
        var labels = bq.messages && bq.messages.recommendations
            ? bq.messages.recommendations
            : this.options.labels;
        return (labels && labels.allGroups) ? labels.allGroups : 'All Forecasted Items';
    },

    _defaultGroupLabel: function() {
        var labels = bq.messages && bq.messages.recommendations
            ? bq.messages.recommendations
            : this.options.labels;
        return (labels && labels.defaultGroup) ? labels.defaultGroup : 'Default';
    },

    _populateCatalogGroupDropdown: function(items) {
        var self      = this;
        var id        = this._id();
        var allLabel  = this._allGroupsLabel();
        var defLabel  = this._defaultGroupLabel();
        var defValue  = bq.recommendationsViewer.DEFAULT_GROUP;
        var $wrap     = $('#' + id + '-catalog-group-filter-wrap');
        var $dropdown = $('#' + id + '-catalog-group-dropdown');

        // Collect ordered unique group names present across all items
        var seen         = {};
        var groups       = [];
        var hasUngrouped = false;

        $.each(items || [], function(_, item) {
            var names = item.catalog_group_names;
            if (!names || !names.length) {
                hasUngrouped = true;
                return;
            }
            $.each(names, function(_, name) {
                if (!seen[name]) {
                    seen[name] = true;
                    groups.push(name);
                }
            });
        });

        // Hide when no named groups (includes all-Default case)
        if (!groups.length) {
            self._selectedGroup = '';
            $dropdown.empty().hide();
            $wrap.hide();
            return;
        }

        var selectionValid = !self._selectedGroup
            || (self._selectedGroup === defValue && hasUngrouped)
            || $.inArray(self._selectedGroup, groups) !== -1;

        if (!selectionValid) {
            self._selectedGroup = '';
        }

        $dropdown.empty();
        $dropdown.append(
            $('<button type="button"></button>')
                .addClass('rec-catalog-group-option' + (!self._selectedGroup ? ' is-selected' : ''))
                .attr({ 'data-group': '', title: allLabel })
                .text(allLabel)
        );

        if (hasUngrouped) {
            $dropdown.append(
                $('<button type="button"></button>')
                    .addClass('rec-catalog-group-option' + (self._selectedGroup === defValue ? ' is-selected' : ''))
                    .attr({ 'data-group': defValue, title: defLabel })
                    .text(defLabel)
            );
        }

        $.each(groups, function(_, name) {
            $dropdown.append(
                $('<button type="button"></button>')
                    .addClass('rec-catalog-group-option' + (self._selectedGroup === name ? ' is-selected' : ''))
                    .attr({ 'data-group': name, title: name })
                    .text(name)
            );
        });

        $wrap.show();
    },

    _bindEvents: function() {
        var self   = this;
        var id     = this._id();
        var labels = bq.messages.recommendations;

        $(document).off('bq.ajaxAction.processDone.recViewer').on('bq.ajaxAction.processDone.recViewer', function(e) {
            var $button = $(e.target);
            if (!$button.closest('#' + id).length) return;
            if (!$button.is('[data-bq="add-cart"]') && !$button.closest('[data-bq="add-cart"]').length) return;
            if (!$button.is('[data-bq="add-cart"]')) { $button = $button.closest('[data-bq="add-cart"]'); }
            var $card = $button.closest('.recommendation-item-card');
            if (!$card.length) return;
            self._removeItemFromMemory($card.data('product-id'), $card.data('supplier'), $card.data('sku'), $card.data('recommendation-source'));
            $card.fadeOut(300, function() { $(this).remove(); self._sortAndFilter(); });
        });

        $('#' + id + '-confirm-order').off('click.confirmOrder').on('click.confirmOrder', function() {
            var $btn = $(this);
            var $active = $('#' + id + '-grouped-items .recommendation-item-card:visible').not('.skipped-item');
            if (!$active.length) { return; }

            self._orderErrors   = [];
            self._orderWarnings = [];
            self._simpleItems   = [];

            $btn.prop('disabled', true);
            var origText = $btn.html();
            $btn.html('<span class="fa fa-spinner fa-spin"></span> ' + labels.processing);

            $active.each(function() {
                var $c = $(this);
                var isConf = $c.attr('data-is-configurable') === '1';
                if (isConf) { return; }
                var qtyId = $c.attr('data-qty-input-id');
                var qty   = qtyId ? parseInt($('#' + qtyId).val()) || 1 : 1;
                self._simpleItems.push({
                    productId:             $c.data('product-id'),
                    productName:           $c.find('.item-name').text().trim(),
                    sku:                   $c.data('sku'),
                    supplier:              $c.data('supplier'),
                    recommendationSource:  $c.data('recommendation-source'),
                    qty:                   qty
                });
            });

            var reasons = self._collectProductReasons();
            self._sendConfirmationReasons(reasons);

            $btn.prop('disabled', false).html(origText);

            if (!self._simpleItems.length) {
                if (self._processConfigurableItems()) { return; }
                return;
            }
            if (self._processConfigurableItems()) { return; }
            self._processAllConfiguredItems();
        });

        $('#' + id + '-config-next-btn').off('click.configNext').on('click.configNext', function() {
            if (!self._validateCurrentConfigForm()) {
                alert(labels.pleaseSelectOptions);
                return;
            }
            self._captureCurrentConfigData();
            self._showConfigurableItem(self._configurableIndex + 1);
        });

        $('#' + id + '-config-skip-btn').off('click.configSkip').on('click.configSkip', function() {
            var $skipSection = $('#' + id + '-config-skip-section');
            var $skipBtn     = $(this);
            if ($skipSection.is(':visible')) {
                var reason = $('#' + id + '-config-skip-reason').val().trim();
                var item   = self._configurableQueue[self._configurableIndex];
                var externalIds = [];
                try { externalIds = JSON.parse((item.externalIds || '[]').replace(/&quot;/g, '"')); } catch(e) {}
                if (externalIds.length > 0) {
                    self._configurableSkipped.push({ external_ids: externalIds, reason_type: 'SKIP', reason: reason });
                }
                self._showConfigurableItem(self._configurableIndex + 1);
            } else {
                $skipSection.slideDown(200);
                $skipBtn.text(labels.confirmSkip);
            }
        });

        $('#' + id + '-catalog-group-toggle').off('click.catalogGroupToggle').on('click.catalogGroupToggle', function(e) {
            e.preventDefault();
            $('#' + id + '-confidence-filter-dropdown').hide();
            $('#' + id + '-catalog-group-dropdown').toggle();
        });

        $('#' + id + '-catalog-group-dropdown').off('click.catalogGroupOption').on('click.catalogGroupOption', '.rec-catalog-group-option', function() {
            var group = String($(this).attr('data-group') || '');
            self._selectedGroup = group;
            $('#' + id + '-catalog-group-dropdown .rec-catalog-group-option').removeClass('is-selected');
            $(this).addClass('is-selected');
            $('#' + id + '-catalog-group-dropdown').hide();
            self._applyFilters();
        });

        $('#' + id + '-confidence-filter-toggle').off('click.filterToggle').on('click.filterToggle', function(e) {
            e.preventDefault();
            $('#' + id + '-catalog-group-dropdown').hide();
            $('#' + id + '-confidence-filter-dropdown').toggle();
        });

        $(document).off('click.filterDropdown').on('click.filterDropdown', function(e) {
            var $t = $(e.target);
            if (!$t.closest('#' + id + '-confidence-filter-toggle').length && !$t.closest('#' + id + '-confidence-filter-dropdown').length) {
                $('#' + id + '-confidence-filter-dropdown').hide();
            }
            if (!$t.closest('#' + id + '-catalog-group-toggle').length && !$t.closest('#' + id + '-catalog-group-dropdown').length) {
                $('#' + id + '-catalog-group-dropdown').hide();
            }
        });

        $('#' + id + '-confidence-filter-dropdown').off('change.filterCheckbox').on('change.filterCheckbox', '.rec-filter-toggle', function() {
            var $cb  = $(this);
            var key  = String($cb.data('filter-key') || '');
            if (self._filterState.hasOwnProperty(key)) {
                self._filterState[key] = $cb.is(':checked');
                self._applyFilters();
            }
        });

        var searchTimer = null;
        $('#' + id + '-search').off('input.recSearch').on('input.recSearch', function() {
            var value = $(this).val();
            clearTimeout(searchTimer);
            searchTimer = setTimeout(function() {
                self._searchTerm = String(value || '').trim();
                self._computeSearchMatches();
                self._applyFilters();
            }, 150);
        });
    }
};

var old = $.fn.recommendationsViewer;
$.fn.recommendationsViewer = function(option) {
    return this.each(function() {
        var $this   = $(this);
        var data    = $this.data('bq.recommendationsViewer');
        var options = typeof option === 'object' && option;
        if (!data) { $this.data('bq.recommendationsViewer', new bq.recommendationsViewer(this, options)); }
    });
};
$.fn.recommendationsViewer.Constructor = bq.recommendationsViewer;
$.fn.recommendationsViewer.noConflict  = function() { $.fn.recommendationsViewer = old; return this; };

bq.recommendationsViewerInit = function() {
    $('[data-bq="recommendations-viewer"]').each(function() {
        var $el = $(this);
        if (!$el.data('bq.recommendationsViewer')) { $el.recommendationsViewer(); }
    });
};
bq.init.push(bq.recommendationsViewerInit);
bq.recommendationsViewerInit();

});}( window, document, bq));
